//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Paper, Typography } from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import IllustrationGhost from '@core/illustrations/IllustrationGhost.svg'

import translations from './NoResultsBanner.translations'

export default {
  components: {
    IllustrationGhost,
    Paper,
    Typography,
  },
  computed: {
    translations: () => translations,
    ...mapGetters({
      landingTitle: 'landing/title',
    }),
  },
}
